
<template>
  <v-bottom-sheet v-model="bottomSheet">
    <v-layout>
      <v-flex xs12>
           <v-card flat  primary style="min-height:300px"> 
               <v-layout row wrap>
                    <v-card-text>
                        <template>
                            <v-flex xs12 sm12 >
                                <div v-for="processlog in processlogs" :key="processlog.id">
                                    <v-flex sm2 md2 xs2>  
                                        <v-card dense  style="min-height:150px">
                                            <v-card-title dense  class="cyan" xs12 style="height:3s0px;padding-top:5px;margin-top:2px">
                                                    
                                                    <span class="text-xs-left body-2" ><strong>{{edi_documents.doc_name}}</strong></span>
                                                    <v-spacer/>
                                                    <br/>
                                                 
                                                    <span class="text-xs-left body-2" >{{edi_documents.transaction_id}}</span>
                                                <v-spacer/>
                                                <td>
                                                    <v-icon  small color="red" @click="Cancel()">fa fa-times</v-icon>
                                                </td>

                                                 </v-card-title> 

                                                 <v-divider/>
                                            <div>
                                            <v-card-text>
                                           <v-layout row  class="justify-center" style="padding:10px">
                                                <Socket  class = '#36D7B7'  style="zoom:60%"></Socket>
                                                 
                                            </v-layout>
                                            
                                            </v-card-text>
                                            </div>
                                            <v-spacer/>
                                            <v-layout row wrap style="padding:5px">
                                                 <strong><span class="text-xs-left body-2">{{partners.name}}</span></strong>
                                            </v-layout>
                                           
                                            <v-layout row wrap style="padding:5px">
                                          <div>  
                                         
                                         <p>Process time:{{time}}</p>
                                        
                                         </div>
                                            </v-layout>
                                        </v-card>
                                    </v-flex>
                                </div>
                            </v-flex>
                       </template>
                   </v-card-text>
               </v-layout>
           </v-card>
      </v-flex>
   </v-layout>
   </v-bottom-sheet>
</template>
<script>

import {RotateSquare2} from 'vue-loading-spinner'
import {Socket} from 'vue-loading-spinner'
export default {
    components: {
      RotateSquare2,
      Socket
    },
   props:
   [
       "bottomSheet"
       ],
   
    data () {
      return {
            
       
            processlogs  : {},
            edi_documents:{},
            edidocuments:{},
            partners:{}
      }
    },
    
    created: function() {

    },
    mounted: function(){
        
    },
    computed:{
        time: function(){
        
            var now  = new Date();
            var then = start_time;
            var diff = moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss"));
            var d = moment.duration(diff);
            var s = d.format("hh:mm:ss");
        }   
 },
    methods: {
       setProcesslog($processlogs){
        this.processlogs = $processlogs;
        this.edi_documents = $processlogs[0].edi_documents
        console.log(this.edi_documents)
        console.log(this.processlogs)

        },
        setEdiDocument($edidocuments){
        this.edidocuments = $edidocuments;
        this.partners = $edidocuments[0].partners
        console.log(this.partners)
        console.log(this.edidocuments)

        },
        Cancel()
        {
       this.bottomSheet=false
        },
        
                
          

    }
        
  
  }
</script>
